import { Star, StarOff } from "lucide-react";
import type { ActionItem } from "@/shared/components/ActionMenu";
import type { LedgerAllocationOperationType } from "../types/accounting.types";

/**
 * YTI-2011 - catégorie par défaut des remboursements. Un remboursement réglé
 * part dans la catégorie désignée de son périmètre (ASC/AEP), quel que soit
 * son nom : sans elle, l'API cherche « Remboursements » et la recrée si
 * l'élu l'a renommée.
 */
export const isRefundDefault = (category: LedgerAllocationOperationType) => category.default_for === "refund";

/** Rien sur une recette : un remboursement est toujours une dépense. */
export const refundDefaultActions = (
  category: LedgerAllocationOperationType,
  onChange: (category: LedgerAllocationOperationType, defaultFor: "refund" | null) => void,
): ActionItem[] => {
  if (isRefundDefault(category)) {
    return [{ label: "Retirer le défaut remboursements", icon: StarOff, onClick: () => onChange(category, null) }];
  }
  if (category.nature === "revenue") return [];
  return [{ label: "Par défaut pour les remboursements", icon: Star, onClick: () => onChange(category, "refund") }];
};

export const refundDefaultSuccessMessage = (category: LedgerAllocationOperationType, defaultFor: "refund" | null) => (
  defaultFor
    ? `Les remboursements réglés iront désormais dans « ${category.name} »`
    : `« ${category.name} » n'est plus la catégorie par défaut des remboursements`
);
